import { observable, computed, action, runInAction } from 'mobx';
import autobind from 'autobind-decorator';
import { asyncAction } from 'mobx-utils';
import { ScoreService } from 'services';
import WebSocketUtil from 'common/utils/socketUtil';
import SoccerModel from 'routes/score/soccer/store/model';
import BaseballModel from 'routes/score/baseball/store/model';
import BasketballModel from 'routes/score/basketball/store/model';
import VolleyballModel from 'routes/score/volleyball/store/model';
import HockeyModel from 'routes/score/hockey/store/model';
import FootballModel from 'routes/score/football/store/model';
import TennisModel from 'routes/score/tennis/store/model';
import { getFilterList, getConcatList, getReadyList } from './util';
import { _SPORTS_WS_TOPIC } from 'common/constants/sportsConstants';

@autobind
class BetbleLiveStore {
  socket = null;
  isSub = false;

  @observable
  sportsView = {
    soccer: [],
    baseball: [],
    basketball: [],
    volleyball: [],
    hockey: [],
    football: [],
    tennis: []
  };

  @observable
  loading = true;

  @observable
  selectedPage = 1;

  constructor() {}

  connectSocket(topic, type = null) {
    this.socket = new WebSocketUtil(topic);

    this.socket.ws.onmessage = (event) => {
      if (event) {
        let data = event.data;

        try {
          if (data === 'OK') {
            this.isSub = true;
          } else {
            let messageData = JSON.parse(data);

            if (messageData) {
              const { TOPIC, MESSAGE } = messageData;

              if (TOPIC.includes('sports')) {
                const data = JSON.parse(MESSAGE);
                const { sportsView } = this;
                const sportsTypeKeyArr = Object.keys(sportsView);
                let index = -1;

                sportsTypeKeyArr.forEach((key) => {
                  if (data.hasOwnProperty('gameId')) {
                    index = sportsView[key].findIndex(
                      (item) => item.id === data.gameId
                    );
                  }

                  if (TOPIC.includes(key)) {
                    [
                      'sports.soccer.games',
                      'sports.baseball.games',
                      'sports.basketball.games',
                      'sports.volleyball.games',
                      'sports.hockey.games',
                      'other.sports.tennis.games'
                    ].forEach((item) => {
                      if (TOPIC === `${item}`) {
                        if (Boolean(~index)) {
                          if (TOPIC.includes('games')) {
                            if (key === 'basketball' || key === 'volleyball') {
                              sportsView[key][index].updateGame(
                                data.game,
                                false,
                                false,
                                true
                              );
                            } else {
                              sportsView[key][index].updateGame(data.game);
                            }
                          }
                        }
                      }
                    });
                  }
                });
              }
            }
          }
        } catch (error) {
          console.log('=== socket on message error ===', error);
        }
      }
    };
  }

  /**********************************************************
   * computed
   **********************************************************/
  @computed
  get liveMatchTrackerList() {
    const { sportsView, selectedPage } = this;
    const sportsTypeKeyArr = Object.keys(sportsView);
    const filterList = getFilterList(sportsTypeKeyArr, sportsView);
    const list = getConcatList(filterList);
    const firstNum = selectedPage === 1 ? 0 : (selectedPage - 1) * 6;
    const lastNum = selectedPage === 1 ? 6 : selectedPage * 6;
    let result = [...list.slice(firstNum, lastNum)];

    return result;
  }

  @computed
  get readyBetbleList() {
    const { sportsView } = this;
    const sportsTypeKeyArr = Object.keys(sportsView);
    const filterList = getReadyList(sportsTypeKeyArr, sportsView);
    const list = getConcatList(filterList);

    return list;
  }

  @computed
  get pageTotalCount() {
    const { sportsView } = this;
    const sportsTypeKeyArr = Object.keys(sportsView);
    const filterList = getFilterList(sportsTypeKeyArr, sportsView);
    const list = getConcatList(filterList);

    return list.length;
  }

  /**********************************************************
   * actions
   **********************************************************/
  @action
  closeSocket() {
    this.socket.close(() => {
      runInAction(() => {
        this.isSub = false;
        this.socket = null;
      });
    });
  }

  @action
  setSelectedPage(page) {
    this.selectedPage = page;
  }

  // @action
  // upTest() {
  //   this.sportsView.soccer.push(
  //     this.sportsView.soccer
  //       .filter((item) => item.gameStatus === 'IN_PROGRESS')
  //       .map((item) => {
  //         item.id += performance.now;
  //         return item;
  //       })[0]
  //   );
  // }

  // @action
  // downTest() {
  //   this.sportsView.soccer.pop();
  // }

  /**********************************************************
   * async actions
   **********************************************************/
  @asyncAction
  *getMajor(date) {
    this.loading = true;

    try {
      // TODO: 웹소켓;
      if (!this.isSub) {
        yield this.connectSocket(
          [
            'sports.soccer.games',
            'sports.baseball.games',
            'sports.basketball.games',
            'sports.volleyball.games',
            'sports.hockey.games',
            'other.sports.tennis.games'
          ]
          // _SPORTS_WS_TOPIC['major'].map((item) => item.topic)
        );
      }

      const result = yield ScoreService.getPopularGames(date);

      if (result) {
        let copySportsView = { ...this.sportsView };

        Object.keys(result).forEach((key) => {
          copySportsView[key] = result[key].map((item) => {
            if (key === 'soccer') {
              return new SoccerModel(item);
            } else if (key === 'baseball') {
              return new BaseballModel(item);
            } else if (key === 'basketball') {
              return new BasketballModel(item);
            } else if (key === 'volleyball') {
              return new VolleyballModel(item);
            } else if (key === 'hockey') {
              return new HockeyModel(item);
            } else if (key === 'football') {
              return new FootballModel(item);
            } else if (key === 'tennis') {
              return new TennisModel(item);
            }
          });
        });

        this.sportsView = copySportsView;
        this.loading = false;
      }
    } catch (error) {
      console.log(error);
    }
  }
}

export default BetbleLiveStore;
